export default __webpack_public_path__ + "static/player1-7a27e34d71a46fc4d2877888a8b62cfc.jpg";